import React from 'react';
import { AlertCircle } from 'lucide-react';
import { usePreviewErrors } from '@/hooks/usePreviewErrors';
import { Button } from "@/components/ui/button";
import commonService from "@/services/common.service.ts";
import { CommonService } from "@/services";
import './ChatErrorIndicatorComponent.scss';

export const ChatErrorIndicatorComponent = () => {
    const { errors, isVisible, clearErrors, constructErrorString } = usePreviewErrors();

    // Filter out Supabase & network errors (same logic as the big card)
    const nonSupabaseErrors = errors.filter((e) => e.type !== 'supabase_connection_issue');
    const shouldShow = nonSupabaseErrors.length > 0 && isVisible;

    if (!shouldShow) return null;

    const handleFixError = () => {
        const errorString = "Fix the following errors:\n\n";
        const errorDescriptions = `<error_description>${constructErrorString(nonSupabaseErrors) || 'Unknown error'}</error_description>`;
        const fullMessage = errorString + '\n\n' + errorDescriptions;

        // Clear errors locally
        clearErrors();

        // Send message to chat
        // We use the same service method to send message
        commonService._communications.sendMessageSubject.next({ message: fullMessage });

        CommonService.handleMixpanelTrack("Fix Error Button Clicked (Chat Pill)", {
            error_count: nonSupabaseErrors.length,
            timestamp: new Date().toISOString()
        });
    };

    return (
        <div className="chat-error-indicator">
            <div className="chat-error-indicator__content">
                <AlertCircle className="w-4 h-4 text-red-500 mr-2" />
                <span className="text-sm font-medium text-red-500 mr-3">
                    {nonSupabaseErrors.length} Issue{nonSupabaseErrors.length > 1 ? 's' : ''}
                </span>
                <Button
                    variant="destructive"
                    size="sm"
                    className="h-7 px-3 text-xs"
                    onClick={handleFixError}
                >
                    Fix
                </Button>
            </div>
        </div>
    );
};
